(ns frontend.ux-overhaul.listing.contract-kyc-profile.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.contract-kyc-profile.event :as contract-kyc-profile-event]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "contract-kyc-profile-listing")

(defn- open-contract-kyc-profile!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/contract-kyc-profile})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/contract-kyc-profile
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :contract-kyc-profile
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-contract-kyc-profile
                                 :label    (loc/tr :contract-kyc-profile-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::contract-kyc-profile-event/create-contract-kyc-profile]}
                                {:id                  :bulk-edit-contract-kyc-profiles
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::contract-kyc-profile-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-contract-kyc-profiles
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::contract-kyc-profile-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-contract-kyc-profiles
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::contract-kyc-profile-event/export-grid {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :contract-kyc-profiles)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.contract-kyc-profile/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::contract-kyc-profile-event/create-contract-kyc-profile])
         :on-row-clicked           open-contract-kyc-profile!
         :on-card-clicked          open-contract-kyc-profile!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/contract-kyc-profile}]])}))
